import React from 'react';
import './reportStyles.css';

const InfoField = ({ label, value }) => (
  <div className="info-field">
    <span className="info-label">{label}</span>
    <span className="info-value">{value || '-'}</span>
  </div>
);

export default InfoField;
